const CLIENT = {
  RESET_CLIENT: "ACTION.LOCAL.CLIENT.RESET_CLIENT",
  UPDATE_CLIENT: "ACTION.LOCAL.CLIENT.UPDATE_CLIENT",
};

export default CLIENT;
